module.exports = __webpack_public_path__ + "static/media/data_center.06924cfe.jpg";